export const EVENTS = {
  COPY_BUTTON: 'copy_button_clicked',
  ENCOUNTER_PAUSE: 'encounter_paused',
  CLICK_EVENT: 'click',
  SLIDER_CHANGE: 'slider_value_changed',
  SLIDER_INCREMENT: 'slider_incremented',
  SLIDER_DECREMENT: 'slider_decremented',
  SLIDER_UNKNOWN: 'slider_unknown_selected',
  MULTISELECT_OPTION_SELECTED: 'multiselect_option_selected',
  MULTISELECT_SEARCH_USED: 'multiselect_search_used',
  TAPPER_STARTED: 'tapper_measurement_started',
  TAPPER_COMPLETED: 'tapper_measurement_completed',
  TAPPER_RESET: 'tapper_measurement_reset',
  TEXT_INPUT_COMPLETED: 'text_input_completed',
  TEXT_INPUT_VALIDATION_FAILED: 'text_input_validation_failed',
  TEXT_INPUT_UNKNOWN_SELECTED: 'text_input_unknown_selected',
  ENCOUNTER_SAVE_STARTED: 'encounter_save_started',
  ENCOUNTER_SAVED: 'encounter_saved',
  ENCOUNTER_DISCARDED: 'encounter_discarded',
  ENCOUNTER_DISCARD_CANCELLED: 'encounter_discard_cancelled',
  LOGIN_ATTEMPTED: 'login_attempted',
  LOGIN_BYPASS_USED: 'login_bypass_used',
  LANGUAGE_CHANGED: 'language_changed',
  ASSESSMENT_STARTED: 'assessment_started',
  DATE_SELECTED: 'date_selected',
  DATE_UNKNOWN_SELECTED: 'date_unknown_selected',
  BLOOD_PRESSURE_ENTERED: 'blood_pressure_entered',
  BLOOD_PRESSURE_UNKNOWN_SELECTED: 'blood_pressure_unknown_selected',
  GEOLOCATION_GRANTED: 'geolocation_permission_granted',
  GEOLOCATION_DENIED: 'geolocation_permission_denied',
  ENCOUNTER_RESUMED: 'encounter_resumed',
  SEARCH_NO_RESULTS: 'search_no_results_found',
  MEDICATION_SELECTED: 'medication_selected',
  MEDICATION_NONE_SELECTED: 'medication_none_selected',
  USER_IDENTIFIED: 'user_identified',
  USER_ID_CHANGED: 'user_id_changed',
  DEVICE_REGISTERED: 'device_registered',
  TRIAGE_NO_SELECTION: 'triage_no_selection',
  TRIAGE_PANEL_VIEWED: 'triage_panel_viewed',
  CARE_PLAN_VIEWED: 'care_plan_viewed',
  FLEXI_MODE_SELECTED: 'flexi_mode_selected',

  // === Flexi Text Mode Events ===
  FLEXI_TEXT_MODE_STARTED: 'flexi_text_mode_started',
  FLEXI_TEXT_NOTE_SUBMITTED: 'flexi_text_note_submitted',
  FLEXI_TEXT_NOTE_RESUBMIT_REQUESTED: 'flexi_text_note_resubmit_requested',
  FLEXI_TEXT_RHS_EDIT_STARTED: 'flexi_text_rhs_edit_started',
  FLEXI_TEXT_RHS_EDIT_SUBMITTED: 'flexi_text_rhs_edit_submitted',
  FLEXI_TEXT_ASSESSMENT_COMPLETED: 'flexi_text_assessment_completed',
  FLEXI_TEXT_FINALIZE_SAVE_CLICKED: 'flexi_text_finalize_save_clicked',
  FLEXI_TEXT_QUESTION_ANSWERED: 'flexi_text_question_answered',
  FLEXI_TEXT_QUESTIONS_SUBMITTED: 'flexi_text_questions_submitted',
  FLEXI_TEXT_ALERT_SHOWN: 'flexi_text_alert_shown',
  FLEXI_TEXT_ALERT_ACTION_CLICKED: 'flexi_text_alert_action_clicked',
  FLEXI_TEXT_EXTRACTION_NO_MAPPING: 'flexi_text_extraction_no_mapping',
  FLEXI_TEXT_FOCUSED_TO_COMPREHENSIVE_PROMPTED: 'flexi_text_focused_to_comprehensive_prompted',
  FLEXI_TEXT_NETWORK_ERROR_SHOWN: 'flexi_text_network_error_shown',
  FLEXI_TEXT_NETWORK_ERROR_RETRY_CLICKED: 'flexi_text_network_error_retry_clicked',

  FLEXI_GUIDED_MODE_STARTED: 'flexi_guided_mode_started',
  FLEXI_GUIDED_ASSESSMENT_SELECTED: 'flexi_guided_assessment_selected',
  FLEXI_GUIDED_QUESTION_VIEWED: 'flexi_guided_question_viewed',
  FLEXI_GUIDED_QUESTION_ANSWERED: 'flexi_guided_question_answered',
  FLEXI_GUIDED_ANSWER_EDITED: 'flexi_guided_answer_edited',
  FLEXI_GUIDED_SUMMARY_VIEWED: 'flexi_guided_summary_viewed',
  FLEXI_GUIDED_ASSESSMENT_COMPLETED: 'flexi_guided_assessment_completed',
  FLEXI_GUIDED_FINALIZE_SAVE_CLICKED: 'flexi_guided_finalize_save_clicked',

  // === Global Panel Events (Broadness — applies to ALL panels) ===
  PANEL_VIEW: 'panel_view',
  PANEL_EXIT: 'panel_exit',

  // === PVI (Patient Visit & Insights) Events ===
  PV_PAGE_VIEW: 'pv_page_view',
  PV_PAGE_EXIT: 'pv_page_exit',
  PV_FILTER_CHANGED: 'pv_filter_changed',
  PV_METRIC_CLICKED: 'pv_metric_clicked',
  PV_PATIENT_TRACK_TOGGLED: 'pv_patient_track_toggled',
  PV_CONDITION_ROW_EXPANDED: 'pv_condition_row_expanded',
  PV_OLDER_SEARCH_ATTEMPT: 'pv_older_search_attempt',
  PV_DISCLAIMER_SHOWN: 'pv_disclaimer_shown',
  PV_DISCLAIMER_INTERACTED: 'pv_disclaimer_interacted',
  PV_REFRESH_CLICKED: 'pv_refresh_clicked',
  PV_HEADER_CONTEXT_CLICKED: 'pv_header_context_clicked',
  PV_DATE_RANGE_APPLIED: 'pv_date_range_applied',
}

export const PVI_PANEL_NAME = 'past-visits'
